// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEventLiveStreamGetBody = {
  eventId: string;
  cursor?: string | null;
};

export type typeEventLiveStreamGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    eventId: string;
    entries: {
      entryId: string;
      occurredAt: string;
      kind:
        | "point"
        | "penalty"
        | "injury"
        | "periodStart"
        | "periodEnd"
        | "eventStart"
        | "eventEnd"
        | "other";
      description: string;
      teamId?: string | null;
      homeScore?: number | null;
      awayScore?: number | null;
    }[];
    nextCursor?: string | null;
    refreshAfterSeconds: number;
  };
};

export type typeEventLiveStreamGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventLiveStreamGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventLiveStreamGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEventLiveStreamGetBody = {
  type: "object",
  properties: {
    eventId: { type: "string", maxLength: 3000, minLength: 1 },
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["eventId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEventLiveStreamGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEventLiveStreamGetBody);
  }

  return async function postEventLiveStreamGet(
    payload: typeEventLiveStreamGetBody,
  ): Promise<
    typeEventLiveStreamGetOutput200 | typeEventLiveStreamGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEventLiveStreamGet" failed before calling the network. #51fbc5891063`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#51fbc5891063" },
        },
        data: null,
      } as typeEventLiveStreamGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/event/live-stream-get`,
      httpMethod: "POST",
      options,
    })) as typeEventLiveStreamGetOutput200 | typeEventLiveStreamGetOutput400;
  };
}
